import React from 'react'
import classnames from 'classnames'

import { DAYS_OF_WEEK } from '../../../WeekView/utils'

export default function DaysOfTheWeek(props) {
  
  return (
    <div className="w-100 border-bottom bg-white">
      {DAYS_OF_WEEK.map((day, index) => (
        <div 
          key={index} 
          className={classnames("d-inline-block text-center p-2", {"border-right": index != 6 })} 
          style={{width: 'calc((100% - 10px) / 7'}}>
          {day}
        </div>
      ))}
      <div className="d-inline-block" style={{width: '10px', height: '10px'}}></div>
    </div>
  )
}
